var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C15.9952 12.4163 12.4163 15.9952 8 16ZM8 10.4C7.55817 10.4 7.2 10.7582 7.2 11.2V11.2C7.2 11.6418 7.55817 12 8 12V12C8.44183 12 8.8 11.6418 8.8 11.2V11.2C8.8 10.7582 8.44183 10.4 8 10.4V10.4ZM8 4C7.55817 4 7.2 4.35817 7.2 4.8V8C7.2 8.44183 7.55817 8.8 8 8.8V8.8C8.44183 8.8 8.8 8.44183 8.8 8V4.8C8.8 4.35817 8.44183 4 8 4V4Z",
    fill: "#EF9351"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFilledIcon);
export default __webpack_public_path__ + "static/media/warning-filled-icon.7bca0ded738a269690961d5a2e7996f0.svg";
export { ForwardRef as ReactComponent };